<template>
  <div class="component">
    <b-container v-if="notifications.length > 0" fluid class="pb-30">
      <b-row class="mt-15">
        <b-breadcrumb>
          <b-breadcrumb-item v-if="isResearchPage" :to="{ name: 'list-research-site' }">Research Site</b-breadcrumb-item>
          <span class="text-style-1" v-if="isResearchPage">&nbsp;/ Research Site Notifications</span>
          <b-breadcrumb-item v-if="!isResearchPage" :to="{ name: 'study-team' }">Study Team</b-breadcrumb-item>
          <span class="text-style-1" v-if="!isResearchPage">&nbsp;/ Study Team Notifications</span>
        </b-breadcrumb>
      </b-row>
      <b-row>
        <b-col cols="10">
          <b-row class="mb-10 research-site-notifi">
            <span v-if="isResearchPage">Research Site Notifications</span>
            <span v-else>Study Team Notifications</span>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="notification-rect">
        <b-col cols="12">
          <table class="table">
            <tbody>
              <tr v-for="(item, index) in notifications" :key="index">
                <td class="notification-text" v-if="item.isEnabled">
                  {{ item.notificationText }}
                  <span v-if="item.dropDown">
                    <span v-if="item.status" class="angle action">
                      <i v-if="item.isOpened" class="fa fa-angle-up" aria-hidden="true" @click="showHideActivity(item)"></i>
                      <i v-if="!item.isOpened" class="fa fa-angle-down" aria-hidden="true" @click="showHideActivity(item)"></i>
                    </span>
                    <span v-else class="angle action">
                      <i class="fa fa-angle-down" aria-hidden="true"></i>
                    </span>
                  </span>
                  <div>
                    <div v-if="item.isOpened">
                      <div v-for="(task, taskIndex) in item.taskList" :key="taskIndex" :class="item.notificationKey == 'PARTICIPANT_IN_RISK' ? 'notification-child-box' : 'notification-child-box-2'">
                        <div v-if="task.isOnEditMode">
                          <div :class="item.notificationKey == 'PARTICIPANT_STEP_RESPONSE' ? 'participants-step-response' : ''">
                            <div v-if="item.notificationKey == 'PARTICIPANT_STEP_RESPONSE' || item.notificationKey == 'PARTICIPANT_SCORE'" class="Select-an-activity">
                              Select an activity
                              <select class="form-control mt-10 caret-down-icon" v-model="task.taskId" @change="onActivityChange(task, item)">
                                <option value="">Select Activity</option>
                                <option v-for="(activity, index) in sortList(item.activityList)" :key="index" v-bind:value="activity.taskId">{{ activity.name }}</option>
                              </select>
                            </div>
                            <div v-if="item.notificationKey != 'PARTICIPANT_STEP_RESPONSE' && item.notificationKey != 'PARTICIPANT_SCORE'" class="Select-an-activity">
                              Select an activity
                              <select class="form-control mt-10 caret-down-icon" v-model="task.taskId" @change="onActivityChange(task, item)">
                                <option value="">Select Activity</option>
                                <option v-for="(activity, index) in item.activityList" :key="index" v-bind:value="activity.taskId">{{ activity.taskTitle }} ({{ activity.taskType }})</option>
                              </select>
                            </div>
                          </div>
                          <div class="participants-step-response" v-if="item.notificationKey == 'PARTICIPANT_STEP_RESPONSE'">
                            <div class="Select-an-activity">
                              Select a step
                              <select class="form-control mt-10 caret-down-icon" v-model="task.stepId" @change="showActivitySteps(task, item)">
                                <option value="" selected="selected" disabled>Select a step</option>
                                <option v-for="(step, index) in activityStepList.filter(activityStep => activityStep.sequence != 100000)" :key="index" v-bind:value="step.id">Step {{ step.sequence }} - {{ step.type }}</option>
                              </select>
                            </div>
                          </div>
                          <div class="participants-step-response-score" v-if="item.notificationKey == 'PARTICIPANT_SCORE'">
                            <div class="Select-an-activity">
                              Score parameters
                              <select class="form-control mt-10 caret-down-icon" @change="persistData(task, item, taskIndex)" v-model="task.scoreParam" :class="task.advanceDays && task.advanceDays.length > 1 ? 'alert-input' : 'alert-input-2'">
                                <option value="" selected="selected" disabled>Select an option</option>
                                <option v-for="(param, index) in scoreParams" :key="index" v-bind:value="param.key">{{ param.label }}</option>
                              </select>
                            </div>
                            <div class="Select-an-activity">
                              <div class="">Score value</div>
                              <b-form-input v-if="task.scoreParam != '>=&&<='" class="form-control mt-10" type="number" v-model="task.scoreVal" required @input="persistData(task, item, taskIndex)"></b-form-input>
                              <div v-else class="row">
                                <div class="col-md-6 pr-0 pl-5">
                                  <b-form-input class="pt-8 pb-7 form-control mt-10" type="number" placeholder="Lower" v-model="task.minScoreVal" required @input="persistData(task, item, taskIndex)"></b-form-input>
                                </div>
                                <div class="col-md-6 pl-0 pr-5">
                                  <b-form-input class="pt-8 pb-7 form-control mt-10" type="number" placeholder="Upper" v-model="task.maxScoreVal" required @input="persistData(task, item, taskIndex)"></b-form-input>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-if="item.notificationKey == 'PARTICIPANT_STEP_RESPONSE'" class="mt-6">
                            <div class="Select-an-activity mb-0 pl-10">
                              Select Recipients
                            </div>
                            <div class="participants-step-response">
                              <dropdown-checkbox-grouped :options="roles" :optionField="'text'" :valueField="'value'" class="group-check-box form-control  caret-down-icon " :input="role" :showModel="showModel" :id="`notification-settings-dropdown-${index}`" @selected-grouped-checkbox-data="selectedElementsFromResearchTeamDropdown($event)" />
                            </div>
                          </div>
                          <div v-if="item.notificationKey == 'PARTICIPANT_SCORE'">
                            <div class="Select-an-activity mb-0">
                              Select Recipients
                            </div>
                            <div class="score-checkbox">
                              <dropdown-checkbox-grouped :options="roles" :optionField="'text'" :valueField="'value'" class="group-check-box form-control  caret-down-icon ml-0 mt-10" :input="role" :showModel="showModel" :id="`notification-settings-dropdown-${index}`" @selected-grouped-checkbox-data="selectedElementsFromResearchTeamDropdown($event)" />
                            </div>
                          </div>

                          <div class="row mb-15" v-if="item.notificationKey == 'PARTICIPANT_IN_RISK'">
                            <div class="Select-an-activity">
                              How far in advance of the due date should sites be notified
                            </div>
                            <div class="row" v-for="(reminder, index) in task.advanceDays" :key="index">
                              <span class="delete-minus action mt-6" v-if="task.advanceDays.length > 1">
                                <span @click="removeAdvanceDay(item, task, reminder, index)">
                                  <i class="fa fa-minus-circle" aria-hidden="true"></i>
                                </span>
                              </span>
                              <select class="form-control w-107" :class="task.advanceDays.length > 1 ? 'ml-5 alert-input' : 'alert-input-2'" v-model="reminder.advanceNotificationDay" @change="onAdvanceDayChange($event, item, task)">
                                <option value="0">Select Day</option>
                                <option v-for="index in task.completionWindow" :key="index" v-bind:value="index">{{ index }}</option>
                              </select>
                              <div class="mt-7" :class="task.advanceDays.length > 1 ? 'days' : 'days-2'">
                                day(s)
                              </div>
                              <div class="space"></div>
                            </div>
                            <div @click="addDays(item, task)" class="Add-multiple-reminde action">
                              Add multiple reminders
                            </div>
                          </div>
                          <div class="row">
                            <div class="mr-auto trash-container">
                              <span class="trash action" @click="deleteActivity(item, task)"><i class="fs-15 fa fa-trash-o" aria-hidden="true"></i></span>
                            </div>
                            <div>
                              <button class="btn save-btn" :disabled="disableRepeatSave" @click="saveActivity(item, task)">
                                Save
                              </button>
                            </div>
                          </div>
                        </div>
                        <div v-if="!task.isOnEditMode && task.isSaved" class="row mb-3">
                          <div class="col-8">
                            <div class="p-box Alert-1-day-in-advan-heading">{{ task.taskTitle }} ({{ task.taskType }})</div>
                            <div v-for="(reminder, index) in task.advanceDays" :key="index">
                              <div class="p-13 Alert-1-day-in-advan">
                                Alert
                                <b
                                  >{{ reminder.advanceNotificationDay }}
                                  <span v-if="reminder.advanceNotificationDay == 1">day</span>
                                  <span v-if="reminder.advanceNotificationDay > 1">days</span>
                                </b>
                                in advance of the due date
                              </div>
                            </div>
                          </div>
                          <div class="col-4">
                            <div class="mt-16"></div>
                            <div>
                              <a @click="editreminders(item, task)" class="Edit text-primary action">Edit</a>
                            </div>
                            <div></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="(item.isOpened && item.activityList && item.taskList && item.activityList.length > item.taskList.length) || (item.notificationKey == 'PARTICIPANT_STEP_RESPONSE' && item.isOpened) || (item.notificationKey == 'PARTICIPANT_SCORE' && item.isOpened)" @click="addAnotherNotification(item)" class="Add-multiple-notification action">
                      Add another notification
                    </div>
                  </div>
                </td>
                <td class="pt-12" v-if="item.isEnabled">
                  <div class="on-off">
                    <div class="t-switch off"><label>Off</label></div>
                    <div class="t-switch">
                      <label class="switch">
                        <input type="checkbox" :disabled="item.notificationKey == 'PATICIPANT_WITHDRAW' || item.notificationKey == 'PARTICIPANT_TRANSFER' || item.notificationKey == 'DYNAMIC_SCHEDULING_NOTIFICATION' || isLoading" v-model="item.status" @change="saveConfigureNotification()" />
                        <div class="slider round"></div>
                      </label>
                    </div>
                    <div class="t-switch on"><label>On</label></div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
    </b-container>
    <b-container v-else class="snippet" data-title=".dot-stretching">
      <div class="stage">
        <div class="dot-stretching"></div>
      </div>
    </b-container>
  </div>
</template>

<script>
import nprogress from "nprogress";
import "nprogress/nprogress.css";
import toastr from "toastr";
import swal from "sweetalert2";
import _ from "lodash";
import DropdownCheckboxGrouped from "@/components/common/dynamic-scheduling-components-collection/dropdown-checkbox-grouped.vue";

export default {
  components: {
    DropdownCheckboxGrouped
  },
  data() {
    return {
      isScore: "",
      name: "",
      studyId: "",
      isResearchPage: true,
      notifications: [],
      isLoading: false,
      activityList: [],
      activityTypes: [],
      activityStepList: [],
      taskList: [],
      isInEditMode: false,
      disableRepeatSave: false,
      scoreParams: [
        { key: ">=", label: "Greater than or equal to" },
        { key: "<=", label: "Less than or equal to" },
        { key: "==", label: "Equal to" },
        { key: ">=&&<=", label: "Within a range" }
      ],
      roleValue: "",
      roleKey: "",
      role: {},
      roles: {
        siteTeamRoles: [
          { text: "Principal Investigator", value: "Pi" },
          { text: "Sub-Investigator", value: "SubPi" },
          { text: "Study Coordinator", value: "StudyCoordinator" },
          { text: "Home Health", value: "HomeHealth" },
          { text: "Call Center", value: "CallCenter" },
          { text: "Rater", value: "Rater" },
          { text: "Site Data Lock", value: "Site Data Lock" }
        ],
        studyTeamRoles: [
          { text: "Clinical Research Associate (Blinded)", value: "Cra" },
          { text: "Clinical Research Associate (Unblinded)", value: "CraUB" },
          { text: "Data Management", value: "Dm" },
          { text: "Quality", value: "Quality" },
          { text: "Biostatistics", value: "Biostatistics" },
          { text: "Interviewer", value: "Interviewer" },
          { text: "Pharmacovigilance", value: "Pharmacovigilance" },
          { text: "Home Health Coordinator", value: "Home Health Coordinator" }
        ]
      },
      showModel: false
    };
  },
  mounted() {
    if (this.$route.name == "research-site-notifications") {
      this.isResearchPage = true;
    }
    if (this.$route.name == "study-team-notifications") {
      this.isResearchPage = false;
    }
    this.studyId = this.$route.params.studyId;
    this.getConfigureNotification();
    this.getActivityTypeList();
    this.showRoleBaseDropdown();
  },
  created() {
    window.addEventListener("click", this.close);
  },
  methods: {
    close(e) {
      if (this.$el.contains(e.target)) {
        this.showModel = !this.showModel;
      }
    },
    showRoleBaseDropdown() {
      if (this.$route.name == "research-site-notifications") {
        const objectRoles = Object.assign({}, [this.roles.siteTeamRoles]);
        this.roles["siteTeamRoles"] = objectRoles["0"];
        delete this.roles.studyTeamRoles;
        this.roleKey = "siteTeamRoles";
      } else {
        const objectRoles = Object.assign({}, [this.roles.studyTeamRoles]);
        this.roles["studyTeamRoles"] = objectRoles["0"];
        delete this.roles.siteTeamRoles;
        this.roleKey = "studyTeamRoles";
      }
    },
    selectedElementsFromResearchTeamDropdown(data) {
      this.roleKey = Object.keys(data)[0];
      this.roleValue = "";
      data[this.roleKey].forEach((i, index) => {
        if (index == data[this.roleKey].length - 1) {
          this.roleValue += i;
        } else {
          this.roleValue += i + ",";
        }
      });
    },
    persistData(task, item, index) {
      Object.assign(item.taskList[index], task);
      if (task.taskId != "" && task.taskId != null) {
        let scorePara = [];
        scorePara = item.taskList.filter(scoreObj => scoreObj.taskId == task.taskId && scoreObj.scoreParam == task.scoreParam && ((task.scoreVal && scoreObj.scoreVal == task.scoreVal) || (task.minScoreVal && scoreObj.minScoreVal == task.minScoreVal && task.maxScoreVal && scoreObj.maxScoreVal == task.maxScoreVal)));
        const findObj = item.activityList.find(obj => {
          return obj.activityId == task.taskId;
        });
        if (findObj) {
          task.taskType = findObj.taskType;
          task.taskTitle = findObj.taskTitle;
          task.notificationTypeId = findObj.notificationTypeId;
          task.studyNotificationSettingId = findObj.studyNotificationSettingId;
        }
        if (scorePara.length > 1) {
          this.disableRepeatSave = true;
          this.$toastr.error("Notifications has already been set up for this combination. Please select a different activity.");
          task.advanceDays.push({
            advanceNotificationDay: 0,
            methodType: "save"
          });
          return;
        }
        this.disableRepeatSave = false;
      }
      this.$forceUpdate();
    },
    sortList(activities) {
      return activities.sort(function(a, b) {
        const nameA = a.name.toUpperCase(); // ignore upper and lowercase
        const nameB = b.name.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });
    },
    getActivityTypeList() {
      this.$api.getActivityTypes().then(types => {
        this.activityTypes = types.ok ? types.body.result : [];
      });
    },
    showActivitySteps(task, item) {
      if (task.taskId != "" && task.taskId != null) {
        let activityRes = [];
        activityRes = item.taskList.filter(taskObj => taskObj.taskId == task.taskId && taskObj.stepId == task.stepId);
        if (activityRes.length > 1) {
          this.disableRepeatSave = true;
          this.$toastr.error("Notifications has already been set up for this combination. Please select a different activity.");
          task.advanceDays = [];
          task.completionWindow = 0;
          task.advanceDays.push({
            advanceNotificationDay: 0,
            methodType: "save"
          });
          this.$forceUpdate();
          return;
        }
        this.disableRepeatSave = false;
        let activity = {};
        item.activityList.forEach(obj => {
          obj.steps.forEach(obj1 => {
            if (obj.taskId == task.taskId && obj1.id == task.stepId) {
              activity = obj;
            }
          });
        });
        const index = item.taskList.findIndex(item => item.taskId == task.taskId && item.stepId == task.stepId);
        if (index >= 0) {
          item.taskList[index][this.roleKey] = this.roleValue;
          item.taskList[index] = {
            notificationTypeId: activity.notificationTypeId,
            studyNotificationSettingId: activity.studyNotificationSettingId,
            studyId: activity.studyId,
            stepId: task.stepId,
            taskTitle: activity.taskTitle,
            taskType: activity.taskType,
            taskId: activity.taskId,
            completionWindow: activity.completionWindow <= 1 ? 1 : activity.completionWindow,
            advanceDays: item.taskList[index].advanceDays,
            isOnEditMode: true
          };
        }
        if (item.notificationKey == "PARTICIPANT_STEP_RESPONSE") {
          this.activityStepList = activity.steps;
        }
        this.$forceUpdate();
      } else {
        if (task.taskId == "") {
          task.advanceDays = [];
          task.completionWindow = 0;
          task.advanceDays.push({
            advanceNotificationDay: 0,
            methodType: "save"
          });
          this.$forceUpdate();
        }
      }
    },
    onActivityChange(task, item) {
      if (task.taskId != "" && task.taskId != null) {
        let found = [];
        found = item.taskList.filter(item => item.taskId == task.taskId);
        if (found.length > 1) {
          this.disableRepeatSave = true;
          this.$toastr.error("Notifications have already been set up for this activity. Please select a different activity.");
          task.advanceDays = [];
          task.completionWindow = 0;
          task.advanceDays.push({
            advanceNotificationDay: 0,
            methodType: "save"
          });
          this.$forceUpdate();
          return;
        }
        this.disableRepeatSave = false;
        const activity = item.activityList.find(item => item.taskId == task.taskId);
        const index = item.taskList.findIndex(item => item.taskId == task.taskId);
        const obj = {
          notificationTypeId: activity.notificationTypeId,
          studyNotificationSettingId: activity.studyNotificationSettingId,
          studyId: activity.studyId,
          taskTitle: activity.taskTitle,
          taskType: activity.taskType,
          taskId: activity.taskId,
          completionWindow: activity.completionWindow <= 1 ? 1 : activity.completionWindow,
          advanceDays: item.taskList[index].advanceDays,
          isOnEditMode: true
        };
        if (item.taskList[index].taskNotificationConfigurationId) {
          obj.taskNotificationConfigurationId = item.taskList[index].taskNotificationConfigurationId;
        }
        item.taskList[index] = obj;
        if (item.notificationKey == "PARTICIPANT_STEP_RESPONSE") {
          this.activityStepList = activity.steps;
        }
        this.$forceUpdate();
      } else {
        if (task.taskId == "") {
          task.advanceDays = [];
          task.completionWindow = 0;
          task.advanceDays.push({
            advanceNotificationDay: 0,
            methodType: "save"
          });
          this.$forceUpdate();
        }
      }
    },
    // Show and Hide accordion
    showHideActivity(item) {
      item.isOpened = !item.isOpened;
      if (item.isOpened) {
        item.activityList = [];
        new Promise(resolve => {
          if (item.notificationKey == "PARTICIPANT_STEP_RESPONSE" || item.notificationKey == "PARTICIPANT_SCORE") {
            if (this.activityTypes.length > 0) {
              this.$api.getNotificationActivityV3List({ studyId: this.studyId }).then(response => {
                const sitTeamActivityListResponse = response.ok ? response.body : [];
                sitTeamActivityListResponse.forEach(ele => {
                  ele.name = ele.name + " " + "(Site Team)";
                });
                this.$api
                  .getNotificationSurveyActivityList({
                    studyId: this.studyId
                  })
                  .then(response => {
                    const participantActivityListResponse = response.ok ? response.body : [];
                    participantActivityListResponse.forEach(data => {
                      data.name = data.name + " " + "(Participant)";
                    });
                    let responseBody = [...sitTeamActivityListResponse, ...participantActivityListResponse];
                    responseBody = responseBody.map(e => {
                      const typeNameIndex = _.findIndex(this.activityTypes, function(o) {
                        return o.id == e.typeId;
                      });
                      e["taskType"] = this.activityTypes[typeNameIndex].type;
                      e["taskTitle"] = e.name;
                      e["notificationTypeId"] = item.notificationTypeId;
                      /*e.typeId;*/ e["taskId"] = e.activityId;
                      e["completionWindow"] = 0;
                      e["studyNotificationSettingId"] = item.studyNotificationSettingId;
                      return e;
                    });
                    item.activityList = [];
                    item.activityList = responseBody;
                    this.$forceUpdate();
                    resolve(responseBody);
                  });
              });
            } else {
              this.$toastr.warning("Unable to fetch activity details.");
            }
          } else {
            this.$api.getActivityList(this.studyId, item.notificationTypeId, item.studyNotificationSettingId).then(response => {
              item.activityList = [];
              item.activityList = response.ok ? response.body : [];
              this.$forceUpdate();
              resolve(response.ok ? response.body : []);
            });
          }
        }).then(resp => {
          let isRiskActivityType;
          if (item.notificationKey == "PARTICIPANT_IN_RISK") {
            isRiskActivityType = true;
          }
          if (item.notificationKey == "PARTICIPANT_NOT_COMPLETED" || item.notificationKey == "PARTICIPANT_COMPLETED" || item.notificationKey == "PARTICIPANT_STEP_RESPONSE" || item.notificationKey == "PARTICIPANT_SCORE") {
            isRiskActivityType = false;
          }
          this.$api.getTaskList(this.studyId, item.studyNotificationSettingId, isRiskActivityType).then(
            response => {
              item.taskList = [];
              item.taskList = response.ok ? response.body : [];
              if (resp) {
                resp.forEach(x => {
                  item.taskList.map(y => {
                    if (x.taskId == y.taskId) {
                      y.completionWindow = x.completionWindow;
                    }
                  });
                });
              }
              item.taskList.forEach(i => {
                if (this.$route.name == "research-site-notifications") {
                  if (i.siteTeamRoles == undefined || i.siteTeamRoles == null) {
                    let roleValue = "";
                    this.roles.siteTeamRoles.forEach((j, index) => {
                      if (index == this.roles.siteTeamRoles.length - 1) {
                        roleValue += j.value;
                      } else {
                        roleValue += j.value + ",";
                      }
                    });
                    i["siteTeamRoles"] = roleValue;
                    this.roleKey = "siteTeamRoles";
                    delete this.roles.studyTeamRoles;
                  }
                } else {
                  if (i.studyTeamRoles == undefined || i.studyTeamRoles == null) {
                    let roleValue = "";
                    this.roles.studyTeamRoles.forEach((j, index) => {
                      if (index == this.roles.studyTeamRoles.length - 1) {
                        roleValue += j.value;
                      } else {
                        roleValue += j.value + ",";
                      }
                    });
                    i["studyTeamRoles"] = roleValue;
                    this.roleKey = "studyTeamRoles";
                    delete this.roles.siteTeamRoles;
                  }
                }
              });
              if (item.taskList.length == 0) {
                let task = {};
                if (item.notificationKey == "PARTICIPANT_STEP_RESPONSE") {
                  task = {
                    notificationTypeId: "",
                    studyNotificationSettingId: "",
                    taskTitle: "",
                    taskType: "",
                    taskId: "",
                    studyId: "",
                    stepId: "",
                    inEditMode: true,
                    isSaved: false,
                    advanceDays: [
                      {
                        advanceNotificationDay: 0,
                        methodType: "save"
                      }
                    ]
                  };
                }
                if (item.notificationKey == "PARTICIPANT_SCORE") {
                  task = {
                    notificationTypeId: "",
                    studyNotificationSettingId: "",
                    taskTitle: "",
                    taskType: "",
                    taskId: "",
                    studyId: "",
                    scoreParam: "",
                    scoreVal: null,
                    maxScoreVal: null,
                    minScoreVal: null,
                    inEditMode: true,
                    isSaved: false,
                    advanceDays: [
                      {
                        advanceNotificationDay: 0,
                        methodType: "save"
                      }
                    ]
                  };
                }
                if (item.notificationKey == "PARTICIPANT_IN_RISK") {
                  task = {
                    notificationTypeId: "",
                    studyNotificationSettingId: "",
                    taskTitle: "",
                    taskType: "",
                    taskId: "",
                    studyId: "",
                    inEditMode: true,
                    isSaved: false,
                    advanceDays: [
                      {
                        advanceNotificationDay: 0,
                        methodType: "save"
                      }
                    ]
                  };
                }
                if (item.notificationKey == "PARTICIPANT_NOT_COMPLETED" || item.notificationKey == "PARTICIPANT_COMPLETED") {
                  task = {
                    notificationTypeId: "",
                    studyNotificationSettingId: "",
                    taskTitle: "",
                    taskType: "",
                    taskId: "",
                    studyId: "",
                    inEditMode: true,
                    isSaved: false
                  };
                }
                item.taskList.push(task);
              }
              item.taskList.map(item => {
                if (item.taskId) {
                  item.isOnEditMode = false;
                  item.isSaved = true;
                } else {
                  item.isOnEditMode = true;
                  item.isSaved = false;
                }
              });
              this.$forceUpdate();
              nprogress.done();
            },
            error => {
              this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting notifications.");
            }
          );
        });
      }
      this.$forceUpdate();
    },
    // API to get notification list
    getConfigureNotification() {
      nprogress.start();
      this.$api.getConfigureNotificationList(this.studyId, this.isResearchPage).then(
        response => {
          const notifications = _.sortBy(response.body, "sortOrder");
          if (this.isResearchPage) {
            this.notifications = notifications;
            this.notifications.forEach(ele => {
              if (ele.teamType === "research" && ele.notificationKey === "PARTICIPANT_TRANSFER") {
                ele.status = true;
              }
            });
          } else {
            this.notifications = notifications.filter(item => item.teamType === "both" || item.teamType === "study");
            this.notifications.forEach(key => {
              if ((key.teamType === "both" || key.teamType === "study") && key.notificationKey === "PARTICIPANT_TRANSFER") {
                key.status = true;
              }
            });
          }
          nprogress.done();
        },
        error => {
          nprogress.done();
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting notifications.");
        }
      );
    },
    // Post API to save notification list
    saveConfigureNotification() {
      this.isLoading = true;
      if (this.isResearchPage) {
        this.notifications.map(item => (item.teamType = "research"));
      } else {
        this.notifications.map(item => (item.teamType = "study"));
      }
      nprogress.start();
      this.$api.saveConfigureNotificationList(this.studyId, this.isResearchPage, this.notifications).then(
        () => {
          this.getConfigureNotification();
          nprogress.done();
          this.isLoading = false;
        },
        error => {
          nprogress.done();
          this.isLoading = false;
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error to save the notifications.");
        }
      );
    },
    // API for save/edit reminders
    getTaskList(notification) {
      let isRiskActivityType;
      if (notification.notificationKey == "PARTICIPANT_IN_RISK") {
        isRiskActivityType = true;
      }
      if (notification.notificationKey == "PARTICIPANT_NOT_COMPLETED" || notification.notificationKey == "PARTICIPANT_COMPLETED" || notification.notificationKey == "PARTICIPANT_STEP_RESPONSE" || notification.notificationKey == "PARTICIPANT_SCORE") {
        isRiskActivityType = false;
      }
      nprogress.start();
      this.$api.getTaskList(this.studyId, notification.studyNotificationSettingId, isRiskActivityType).then(
        response => {
          this.taskList = response;
          nprogress.done();
        },
        error => {
          nprogress.done();
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting task list.");
        }
      );
    },
    // API to get activity list
    getActivityList(notification) {
      nprogress.start();
      this.$api.getActivityList(this.studyId, notification.notificationTypeId, notification.studyNotificationSettingId).then(
        response => {
          this.activityList = response;
          nprogress.done();
        },
        error => {
          nprogress.done();
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting activity list.");
        }
      );
    },
    // TO ADD MULTIPLE DAYS
    addDays(item, task) {
      const advDay = {
        advanceNotificationDay: 0,
        methodType: "save"
      };
      if (task.advanceDays) {
        task.advanceDays.push(advDay);
      } else {
        task.advanceDays = [];
        task.advanceDays.push(advDay);
      }
      this.$forceUpdate();
    },
    // TO ADD MULTIPLE DAYS
    onAdvanceDayChange(event, item, task) {
      const day = event.target.value;
      let advDayCount;
      advDayCount = task.advanceDays.filter(x => x.advanceNotificationDay == day).length;
      if (advDayCount > 1) {
        this.$toastr.warning("This notification is a duplicate. Please revise.");
      }
      this.$forceUpdate();
    },
    // TO REMOVE ADVANCE DAY
    removeAdvanceDay(item, task, reminder, index) {
      swal
        .fire({
          title: "Are you sure you want to delete this?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#4a4a4a",
          cancelButtonColor: "#1e8fe1",
          confirmButtonText: "No",
          cancelButtonText: "Yes"
        })
        .then(({ dismiss }) => {
          if (dismiss === "cancel") {
            nprogress.start();
            let isRiskActivityType;
            if (item.notificationKey == "PARTICIPANT_IN_RISK") {
              isRiskActivityType = true;
            }
            if (item.notificationKey == "PARTICIPANT_NOT_COMPLETED" || item.notificationKey == "PARTICIPANT_COMPLETED" || item.notificationKey == "PARTICIPANT_STEP_RESPONSE" || item.notificationKey == "PARTICIPANT_SCORE") {
              isRiskActivityType = false;
            }

            if (reminder && reminder.taskNotificationConfigurationId) {
              task.advanceDays.map(item => {
                if (item.taskNotificationConfigurationId == reminder.taskNotificationConfigurationId) {
                  item.methodType = "delete";
                } else {
                  item.methodType = "edit";
                }
              });
              const TaskArr = [];
              TaskArr.push(task);
              this.$api.saveTaskActivity(this.studyId, item.studyNotificationSettingId, isRiskActivityType, TaskArr).then(
                () => {
                  const i = item.taskList.findIndex(item => item.taskId === task.taskId);
                  item.taskList[i].advanceDays.splice(index, 1);
                  this.$forceUpdate();
                  nprogress.done();
                },
                error => {
                  nprogress.done();
                  this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting notifications.");
                }
              );
            } else {
              const i = item.taskList.findIndex(item => item.taskId === task.taskId);
              item.taskList[i].advanceDays.splice(index, 1);
              this.$forceUpdate();
              nprogress.done();
            }
          }
        });
    },
    // TO EDIT reminder
    editreminders(item, task) {
      task.isOnEditMode = true;
      this.isInEditMode = true;
      if (item.notificationKey == "PARTICIPANT_STEP_RESPONSE") {
        const selectedActivityList = item.activityList.filter(e => e.activityId == task.taskId);
        this.activityStepList = selectedActivityList[0]["steps"];
        item.taskList.forEach(i => {
          if (i.stepId === task.stepId) {
            if (i.siteTeamRoles) {
              const splitData = i.siteTeamRoles.split(",");
              this.role["siteTeamRoles"] = splitData;
            } else if (i.studyTeamRoles) {
              const splitData = i.studyTeamRoles.split(",");
              this.role["studyTeamRoles"] = splitData;
            }
          }
        });
      } else if (item.notificationKey == "PARTICIPANT_SCORE") {
        item.taskList.forEach(i => {
          if (i.scoreParam === task.scoreParam && ((task.scoreVal && i.scoreVal === task.scoreVal) || (task.minScoreVal && i.minScoreVal === task.minScoreVal && task.maxScoreVal && i.maxScoreVal === task.maxScoreVal))) {
            if (i.siteTeamRoles) {
              const splitData = i.siteTeamRoles.split(",");
              this.role["siteTeamRoles"] = splitData;
            } else if (i.studyTeamRoles) {
              const splitData = i.studyTeamRoles.split(",");
              this.role["studyTeamRoles"] = splitData;
            }
          }
        });
      } else if (item.notificationKey == "PARTICIPANT_IN_RISK") {
        task.completionWindow = task.completionWindow <= 1 ? 1 : task.completionWindow;
      }
      this.$forceUpdate();
    },
    addAnotherNotification(item) {
      this.isInEditMode = false;
      const task = {
        notificationTypeId: "",
        studyNotificationSettingId: "",
        taskTitle: "",
        taskType: "",
        taskId: "",
        studyId: "",
        isOnEditMode: true
      };
      this.role = {};
      if (item.notificationKey == "PARTICIPANT_STEP_RESPONSE") {
        task.stepId = "";
      }
      if (item.notificationKey == "PARTICIPANT_SCORE") {
        task.scoreParam = "";
        task.scoreVal = null;
        task.maxScoreVal = null;
        task.minScoreVal = null;
      }
      if (item.notificationKey == "PARTICIPANT_IN_RISK" || item.notificationKey == "PARTICIPANT_SCORE" || item.notificationKey == "PARTICIPANT_STEP_RESPONSE") {
        task.advanceDays = [];
        const advDay = {
          advanceNotificationDay: 0,
          methodType: "save"
        };
        task.advanceDays.push(advDay);
      }
      item.taskList.push(task);
      this.$forceUpdate();
    },
    saveActivity(item, task) {
      nprogress.start();
      let isActivitySelected = true;
      let isDaySelected = false;
      let isActivityPresent = false;
      let isDayPresent = false;
      let isRiskActivityType;
      if (item.notificationKey == "PARTICIPANT_IN_RISK") {
        isRiskActivityType = true;
        task.advanceDays.map(item => {
          if (item.taskNotificationConfigurationId) {
            item.methodType = "edit";
          } else {
            item.methodType = "save";
          }
        });
        let activityCount;
        activityCount = item.taskList.filter(x => x.taskId === task.taskId).length;
        if (activityCount > 1) {
          isActivityPresent = true;
          this.$toastr.error("Notifications have already been set up for this activity. Please select a different activity.");
          nprogress.done();
          return;
        }
        if (task.taskId == "" || task.taskId == null) {
          isActivitySelected = false;
          this.$toastr.warning("Please select an activity.");
          nprogress.done();
          return;
        }
        isDaySelected = task.advanceDays.some(item => {
          return item.advanceNotificationDay == 0;
        });
        if (isDaySelected) {
          this.$toastr.warning("Please select advance day.");
          nprogress.done();
          return;
        }
        isDayPresent = this.checkIfArrayIsUnique(task.advanceDays);
        if (isDayPresent) {
          this.$toastr.warning("This notification is a duplicate. Please revise.");
          nprogress.done();
          return;
        }
      }
      if (item.notificationKey == "PARTICIPANT_NOT_COMPLETED" || item.notificationKey == "PARTICIPANT_COMPLETED") {
        let activityCount;
        activityCount = item.taskList.filter(x => x.taskId === task.taskId).length;
        if (activityCount > 1) {
          isActivityPresent = true;
          this.$toastr.error("Notifications have already been set up for this activity. Please select a different activity.");
          nprogress.done();
          return;
        }
        if (task.taskId == "" || task.taskId == null) {
          isActivitySelected = false;
          this.$toastr.warning("Please select an activity.");
          nprogress.done();
          return;
        }
        isRiskActivityType = false;
        delete task.completionWindow;
        delete task.advanceDays;
      }
      if (item.notificationKey == "PARTICIPANT_STEP_RESPONSE") {
        isRiskActivityType = false;
        if (task.taskId == "" || task.taskId == null) {
          isActivitySelected = false;
          this.$toastr.warning("Please select an activity.");
          nprogress.done();
          return;
        }
        if (task.stepId == "" || task.stepId == null) {
          isActivitySelected = false;
          this.$toastr.warning("Please select a step.");
          nprogress.done();
          return;
        }
        task.studyId = this.studyId;
        task[this.roleKey] = this.roleValue ? this.roleValue : null;
      }
      if (item.notificationKey == "PARTICIPANT_SCORE") {
        isRiskActivityType = false;
        if (task.taskId == "" || task.taskId == null) {
          isActivitySelected = false;
          this.$toastr.warning("Please select an activity.");
          nprogress.done();
          return;
        }
        //task.taskType = task.name;
        task.studyId = this.studyId;
        if (task.scoreParam == "" || task.scoreParam == null) {
          isActivitySelected = false;
          this.$toastr.warning("Please select score parameter.");
          nprogress.done();
          return;
        }
        if (task.scoreParam != ">=&&<=") {
          if (task.scoreVal == "" || task.scoreVal == null || parseFloat(task.scoreVal) < 0) {
            this.$toastr.warning("Please enter score value.");
            nprogress.done();
            return;
          }

          task.scoreVal = parseFloat(task.scoreVal);
          task.maxScoreVal = null;
          task.minScoreVal = null;
        } else {
          if (task.minScoreVal == "" || task.minScoreVal == null || parseFloat(task.minScoreVal) < 0) {
            this.$toastr.warning("Please enter min value.");
            nprogress.done();
            return;
          }

          if (task.maxScoreVal == "" || task.maxScoreVal == null || parseFloat(task.maxScoreVal) < 0) {
            this.$toastr.warning("Please enter max value.");
            nprogress.done();
            return;
          }

          if (parseFloat(task.maxScoreVal) < parseFloat(task.minScoreVal)) {
            this.$toastr.warning("Please enter max value greater than min value.");
            nprogress.done();
            return;
          }
          task.scoreVal = null;
          task.maxScoreVal = parseFloat(task.maxScoreVal);
          task.minScoreVal = parseFloat(task.minScoreVal);
        }
        task[this.roleKey] = this.roleValue ? this.roleValue : null;
      }
      const TaskArr = [];
      TaskArr.push(task);
      const successCallback = () => {
        const index = item.taskList.findIndex(item => item.taskId === task.taskId);
        item.taskList[index].isSaved = true;
        item.taskList[index].isOnEditMode = false;
        this.isInEditMode = false;
        this.$forceUpdate();
        nprogress.done();
        this.showHideActivity(item);
        toastr.success("Activity saved successfully");
      };
      const errorCallback = error => {
        nprogress.done();
        this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting notifications.");
      };
      this.isInEditMode = !!task.taskNotificationConfigurationId;
      if (isActivitySelected && !isDaySelected && !isActivityPresent && !isDayPresent) {
        if (this.isInEditMode && (item.notificationKey == "PARTICIPANT_NOT_COMPLETED" || item.notificationKey == "PARTICIPANT_COMPLETED" || item.notificationKey == "PARTICIPANT_SCORE" || item.notificationKey == "PARTICIPANT_STEP_RESPONSE")) {
          const methodType = "edit";
          this.$api.updateTaskActivity(this.studyId, item.studyNotificationSettingId, isRiskActivityType, methodType, TaskArr).then(successCallback, errorCallback);
        } else {
          this.$api.saveTaskActivity(this.studyId, item.studyNotificationSettingId, isRiskActivityType, TaskArr).then(successCallback, errorCallback);
        }
      }
    },
    deleteActivity(item, task) {
      swal
        .fire({
          title: "Are you sure you want to delete this notification?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#4a4a4a",
          cancelButtonColor: "#1e8fe1",
          confirmButtonText: "No",
          cancelButtonText: "Yes"
        })
        .then(({ dismiss }) => {
          if (dismiss === "cancel") {
            nprogress.start();
            let isRiskActivityType;
            if (item.notificationKey == "PARTICIPANT_IN_RISK") {
              isRiskActivityType = true;
            }
            if (item.notificationKey == "PARTICIPANT_NOT_COMPLETED" || item.notificationKey == "PARTICIPANT_COMPLETED" || item.notificationKey == "PARTICIPANT_SCORE" || item.notificationKey == "PARTICIPANT_STEP_RESPONSE") {
              isRiskActivityType = false;
              const methodType = "delete";
              task.isTaskDeleteForRiskActivity = true;
              delete task.advanceDays;
              const TaskArr = [];
              TaskArr.push(task);
              this.$api.updateTaskActivity(this.studyId, item.studyNotificationSettingId, isRiskActivityType, methodType, TaskArr).then(
                () => {
                  const index = item.taskList.findIndex(item => item.taskId === task.taskId);
                  item.taskList.splice(index, 1);
                  this.$forceUpdate();
                  nprogress.done();
                },
                error => {
                  nprogress.done();
                  this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while deleting activity.");
                }
              );
            } else {
              task.isTaskDeleteForRiskActivity = true;
              delete task.advanceDays;
              const TaskArr = [];
              TaskArr.push(task);
              this.$api.saveTaskActivity(this.studyId, item.studyNotificationSettingId, isRiskActivityType, TaskArr).then(
                () => {
                  const index = item.taskList.findIndex(item => item.taskId === task.taskId);
                  item.taskList.splice(index, 1);
                  this.$forceUpdate();
                  nprogress.done();
                },
                error => {
                  nprogress.done();
                  this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while deleting activity.");
                }
              );
            }
          }
        });
    },
    checkIfArrayIsUnique(myArray) {
      let isUnique = false;
      for (let i = 0; i < myArray.length; i++) {
        for (let j = i + 1; j < myArray.length; j++) {
          if (myArray[i].advanceNotificationDay == myArray[j].advanceNotificationDay) {
            isUnique = true;
          }
        }
      }
      return isUnique;
    }
  }
};
</script>

<style scoped lang="scss" src="../../../public/static/fonts.scss"></style>
<style scoped lang="scss">
.research-site-notifi {
  width: 330px;
  height: 41px;
  font-family: "Roboto", sans-serif;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: #2d3752;
}
.notification-rect {
  width: 698px;
  min-height: 200px;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  background-color: #ffffff;
  margin-left: 12px !important;
}
.notification-text {
  width: 576px;
  height: 20px;
  font-family: "Roboto", sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #9b9b9b;
}
.switch {
  position: relative;
  display: inline-block;
  width: 34px;
  height: 21px;
  margin: 0px 9px 0px 6px;
  &:disabled {
    cursor: default !important;
  }
}
.switch input {
  display: none;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: -1px;
  left: 0;
  right: -4px;
  bottom: 0;
  border: 2px solid #ccc;
  &:disabled {
    cursor: default;
  }
}
.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 1px;
  background-color: #ccc;
}
input:checked + .slider {
  border: 2px solid #48bf7a;
}
input:checked:disabled + .slider {
  border: 2px solid #48bf7a;
  opacity: 0.5;
  cursor: default;
}
input:checked + .slider:before {
  content: "";
  background-color: #48bf7a;
}
input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}
input:checked + .slider:before {
  position: absolute;
  color: #2ecc71;
  text-align: center;
  font-size: 20px;
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.checkbox {
  width: 12px;
  height: 12px;
}
.notification-child-box {
  width: 543px;
  border-radius: 4px;
  border: solid 1px #e4e8eb;
  background-color: #ffffff;
  margin-top: 19px;
  padding: 20px;
}
.notification-child-box-2 {
  width: 543px;
  min-height: 45px;
  border-radius: 4px;
  border: solid 1px #e4e8eb;
  background-color: #ffffff;
  margin-top: 19px;
  padding: 20px;
}
.notification-child-box-edit {
  width: 543px;
  border-radius: 4px;
  border: solid 1px #e4e8eb;
  background-color: #ffffff;
  margin-top: 19px;
  padding: 20px;
}
.Select-an-activity {
  font-family: Roboto-Regular;
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #4a4a4a;
  margin-bottom: 15px;
}
.participants-step-response {
  margin-bottom: 15px;
  display: inline-flex;
  width: 100%;
  > div {
    width: 80%;
    margin: 10px;
  }
}
.participants-step-response-score {
  margin-bottom: 15px;
  display: inline-flex;
  width: 100%;
  > div {
    width: 50%;
  }
  > div:first-child {
    margin-right: 10px;
  }
  > div:last-child {
    margin-left: 10px;
  }
}
.select-activity {
  width: 467px;
  height: 40px;
  border-radius: 3px;
  border: solid 1px #e4e8eb;
  background-color: #ffffff;
  color: #9b9b9b;
  margin: 15px 0px 0px 0px;
  background: none;
}
.How-far-in-advance-o {
  /*width: 500px;
  height: 20px;*/
  font-family: Roboto-Regular;
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  /*line-height: 1.33;*/
  letter-spacing: normal;
  color: #4a4a4a;
  /*margin: 71px 0px 11px 15px;*/
}
.delete-minus {
  width: 18px;
  height: 18px;
  /*margin: 39px 0px 0px 35px;*/
  font-size: 20px;
  color: #b0bac9;
}
.alert-input {
  /*width: 107px;*/
  height: 40px;
  border-radius: 3px;
  box-shadow: inset 0 1px 2px 0 #e4e8eb;
  border: solid 1px #e4e8eb;
  background-color: #ffffff;
  /*margin: 0px 0px 0px 15px;*/
}
.days {
  width: 43px;
  height: 20px;
  font-family: Roboto-Regular;
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #4a4a4a;
  margin: 0 0 0 5px;
}
.space {
  margin: 25px;
}
.Add-multiple-reminde {
  width: 170px;
  height: 15px;
  font-family: Roboto-Regular;
  font-size: 13px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4c8ce4;
  margin: 8px 0;
}
.trash-container {
  line-height: 2.3em;
}
.trash {
  width: 36px;
  height: 35px;
  padding: 8px 11px 8px;
  opacity: 0.99;
  border-radius: 3px;
  background-color: #d3dfe4;
}
.trash-area {
  position: relative;
  padding: 6px 0px 15px 28px;
}
.trash-area-2 {
  position: relative;
  padding: 100px 0px 15px 28px;
}
.save-btn {
  width: 100px;
  height: 36px;
  background-color: #1e8fe1;
  font-family: Roboto-Regular;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
}
.save-btn-2 {
  width: 100px;
  height: 36px;
  background-color: #1e8fe1;
  margin: 90px 24px 15px 28px;
  font-family: Roboto-Regular;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
}
.select_control {
  background-color: #ffffff;
}
.input-bg {
  background: #ffffff !important;
  color: #4a4a4a !important;
}
.angle {
  position: absolute;
  margin: -5px 0px 0px 12px;
}
.Add-multiple-notification {
  width: 155px;
  height: 15px;
  font-family: Roboto-Regular;
  font-size: 13px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4c8ce4;
  margin: 10px 0px 12px 0px;
}
.Alert-1-day-in-advan {
  width: 280px;
  height: 15px;
  font-family: Roboto-Regular;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
}
.Alert-1-day-in-advan-heading {
  min-width: 440px;
  min-height: 15px;
  font-family: Roboto-Regular;
  font-size: 13px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
}
.Edit {
  width: 23px;
  font-family: "Lato", sans-serif;
  font-size: 13px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #1e8fe1;
  margin-left: 125px;
}
.action {
  cursor: pointer;
}
.mt-102 {
  margin-top: 102px;
}
.table th,
.table td {
  padding: 21px 0px 7px 15px !important;
}
.col-12 {
  padding-right: 0px !important;
  padding-left: 0px !important;
}
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}
.breadcrumb {
  display: -ms-flexbox;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #f5f8fa;
  border-radius: 0.25rem;
}
.text-style-1 {
  color: #9b9b9b;
}
input[disabled] {
  background: #ccc;
}
.alert-input-2 {
  /*width: 107px;*/
  height: 40px;
  border-radius: 3px;
  box-shadow: inset 0 1px 2px 0 #e4e8eb;
  border: solid 1px #e4e8eb;
  background-color: #ffffff;
  /*margin: 0px 0px 0px 15px;*/
  background: none;
  background-repeat: no-repeat;
  background-image: url(/static/img/caret/caret-blue.png);
  background-position: 85px 11px !important;
}
.days-2 {
  width: 43px;
  height: 20px;
  font-family: Roboto-Regular;
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #4a4a4a;
  margin: 0 0 0 5px;
}

.dot-stretching {
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #4c8ce4;
  color: #4c8ce4;
  transform: scale(1.25, 1.25);
  animation: dot-stretching 2s infinite ease-in;
}
.dot-stretching::before,
.dot-stretching::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
}
.dot-stretching::before {
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #4c8ce4;
  color: #4c8ce4;
  animation: dot-stretching-before 2s infinite ease-in;
}
.dot-stretching::after {
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #4c8ce4;
  color: #4c8ce4;
  animation: dot-stretching-after 2s infinite ease-in;
}
@keyframes dot-stretching {
  0% {
    transform: scale(1.25, 1.25);
  }
  50%,
  60% {
    transform: scale(0.8, 0.8);
  }
  100% {
    transform: scale(1.25, 1.25);
  }
}
@keyframes dot-stretching-before {
  0% {
    transform: translate(0) scale(0.7, 0.7);
  }
  50%,
  60% {
    transform: translate(-20px) scale(1, 1);
  }
  100% {
    transform: translate(0) scale(0.7, 0.7);
  }
}
@keyframes dot-stretching-after {
  0% {
    transform: translate(0) scale(0.7, 0.7);
  }
  50%,
  60% {
    transform: translate(20px) scale(1, 1);
  }
  100% {
    transform: translate(0) scale(0.7, 0.7);
  }
}
.stage {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 250px 0 0 0;
  margin: 0 -5%;
  overflow: hidden;
}
.caret-down-icon {
  background-position: calc(100% - 10px) 10px !important;
  background-repeat: no-repeat;
  background-image: url(/static/img/caret/caret.png);
}
.on {
  opacity: 0.7;
  font-family: Roboto-Regular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #666669;
}
.off {
  opacity: 0.7;
  font-family: Roboto-Regular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #666669;
}
.t-switch {
  display: block;
  &:disabled {
    cursor: default !important;
  }
}
.on-off {
  text-align: center;
  display: flex;
}
.p-box {
  padding: 15px 0px 0px 12px;
}
.fa-angle-down {
  font-size: 30px !important;
  font-weight: normal !important;
  font-family: "FontAwesome" !important;
}
.fa-angle-up {
  font-size: 30px !important;
  font-weight: normal !important;
  font-family: "FontAwesome" !important;
}
.fa-trash-o {
  font-weight: normal !important;
  font-family: "FontAwesome" !important;
}
</style>
